import { Col, Colors, Text } from 'basic-ui-lib';
import InputLarge from 'basic-ui-lib/components/Input/InputLarge';
import BaseModal from 'basic-ui-lib/components/Modal/BaseModal';
import MainZone from 'basic-ui-lib/components/screen/MainZone';
import MainZoneTicket from 'basic-ui-lib/components/screen/MainZoneTicket';
import Portrait from 'basic-ui-lib/components/screen/Portrait';
import ThreePortraits from 'basic-ui-lib/components/screen/ThreePortraits';
import ThreeZone from 'basic-ui-lib/components/screen/ThreeZone';
import TwoZone from 'basic-ui-lib/components/screen/TwoZone';
import { LayoutCode } from 'modules/channel/services/constants';
import useGetListLayouts from 'modules/channel/services/hooks/useGetListLayouts';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

interface NewChannelModalProps {
  isOpen?: boolean;
  onClose?: () => void;
}

const ListLayouts = [
  {
    Component: <MainZone border={4} />,
    layoutCode: LayoutCode.MAIN_ONLY,
  },
  {
    Component: <MainZoneTicket border={4} gap={4} />,
    layoutCode: LayoutCode.MAIN_TICKER_BOTTOM,
  },
  {
    Component: <TwoZone border={4} gap={4} />,
    layoutCode: LayoutCode.LEFT_RIGHT,
  },
  {
    Component: <ThreeZone border={4} gap={4} />,
    layoutCode: LayoutCode.MAIN_RIGHT_BOTTOM,
  },
  {
    Component: <ThreePortraits border={4} gap={4} />,
    layoutCode: LayoutCode.THREE_PORTRAITS,
  },
  {
    Component: <Portrait border={4} />,
    layoutCode: LayoutCode.MAIN_PORTRAIT,
  },
];

const NewChannelModal = ({ isOpen, onClose }: NewChannelModalProps) => {
  const navigate = useNavigate();
  const [layoutId, setLayoutId] = useState<string | null>(null);
  const [channelName, setChannelName] = useState<string>('');
  const [dataLayouts] = useGetListLayouts();

  const handleChooseItem = (value: string) => {
    setLayoutId(value);
  };

  const handleContinue = () => {
    navigate('/channel/create', { state: { layoutId: layoutId, channelName: channelName } });
  };

  return (
    <BaseModal
      title='Create New Channel'
      isOpen={isOpen}
      width={1000}
      onClose={onClose}
      okText='Continue'
      onOk={handleContinue}
    >
      <Container>
        <InputLarge placeholder='Channel Name' value={channelName} onChange={(value) => setChannelName(value)} />
        <Col width='100%' height='100%' gap={16}>
          <Text title_h7 medium color='neutral.text.3'>
            Choose Layout
          </Text>
          <Content>
            {dataLayouts?.map((layout) => (
              <ItemLayout
                key={layout.layoutId}
                className={layoutId === layout.layoutId ? 'active' : ''}
                onClick={() => handleChooseItem(layout.layoutId)}
              >
                {ListLayouts.find((item) => item.layoutCode === layout.layoutCode)?.Component}
                <Text title_h9 medium color='neutral.text.5'>
                  {layout.name}
                </Text>
              </ItemLayout>
            ))}
          </Content>
        </Col>
      </Container>
    </BaseModal>
  );
};

export default NewChannelModal;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  align-items: center;
  padding: 0 140px 40px;
  height: 540px;
`;

const Content = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(3, 1fr);
`;

const ItemLayout = styled.div`
  display: flex;
  padding: 4px;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  border-radius: 4px;
  border: 1px solid ${Colors.neutral.border[1]};
  background: ${Colors.neutral.bg[1]};
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);

  &.active {
    border: 2px solid ${Colors.primary[6]};
  }
`;
